// Mutually exclusive recruitment choices from the army rosters.
export const armyChoices = {
  "Gang przemytników": [
    ["Kapłan Ranalda","Kapłan Mananna"],
    ["Doker","Nożownik"],
    ["Rozbójnik","Ogr"]
  ],
  "Cyrkowcy z Ligii Ostermarku": [
    ["Magister Magii","Kapłan Ranalda"],
    ["Siłacz","Żongler"],
    ["Ogr","Niedźwiedź"],
    ["Zaprzęg","Rydwan"]
  ],
  "Muszkieterzy z Nuln": [
    ["Magister Magii","Prezbiter Sigmara"],
    ["Rajtar","Krasnoludzki ranger"],
    ["Wóz bojowy","Rydwan"]
  ],
  "Piechota Morska z Marienburga": [
    ["Czarownik","Kapłan Mananna"],
    ["Przepatrywacz","Bukanier"],
    ["Zaprzęg","Rydwan"]
  ],
  "Strażnicy dróg z Averlandu": [
    ["Magister Magii","Prezbiter Sigmara"],
    ["Rajtar","Pogromca trolli"],
    ["Zaprzęg","Rydwan"]
  ],
  "Zbrojna kompania z Ostlandu": [
    ["Magister Magii","Prezbiter Sigmara"],
    ["Ogr","Przepatrywacz"],
    ["Więźniarka","Rydwan"]
  ],
  "Zbrojni z Middenheim": [
    ["Magister Magii","Kapłan Ulryka"],
    ["Wilczarz","Przepatrywacz"],
    ["Zaprzęg","Rydwan"]
  ],
  "Żołnierze z Reiklandu": [
    ["Rajtar","Flagelant"],
    ["Zaprzęg","Rydwan"],
    ["Magister Magii","Prezbiter Sigmara"]
  ],
  "Zbrojna chorągiew z Kisleva": [
    ["Kapłan Ursuna","Magister Lodu"],
    ["Kozak","Myśliwy"],
    ["Husarz","Nomada"],
    ["Zaprzęg","Rydwan"]
  ],
  "Piraci z Sartosy": [
    ["Kapłan Mananna","Czarownik"],
    ["Przepatrywacz","Ogr"],
    ["Więźniarka","Rydwan"]
  ],
  "Psy Wojny": [
    ["Czarownik","Kapłan Myrmidii"],
    ["Lansjer","Ogr","Ptasznik z Catrazzy"],
    ["Wóz bojowy","Rydwan"]
  ],
  "Raubritterzy z Księstw Granicznych": [
    ["Myśliwy","Zbójca"],
    ["Rozbójnik","Ogr"],
    ["Więźniarka","Rydwan"]
  ],
  "Kupiecka karawana z Arabii": [
    ["Dżinn","Nomada"],
    ["Więźniarka","Latający dywan"]
  ],
  "Amazonki z Lustrii": [
    ["Mara","Zmora"],
    ["Więźniarka","Rydwan"]
  ],
  "Gladiatorzy z Jałowej Krainy": [
    ["Szablozębny","Pogromca trolli"],
    ["Niedźwiedź","Nomada","Ogr"],
    ["Więźniarka","Rydwan"]
  ],
  "Siostry Sigmara": [
    ["Bitewny ołtarz","Rydwan"]
  ],
  "Leśni Elfowie z Athel Loren": [
    ["Tancerz wojny","Driada"],
    ["Jeździec polany","Drzewoduch"]
  ],
  "Elfowie Wysokiego Rodu z Ulthuanu": [
    ["Rydwan z Tiranoc","Lwi Rydwan z Chrace"]
  ],
  "Mroczni Elfowie z Naggaroth": [
    ["Widmo","Wiedźma Khaina"],
    ["Jeździec Mroku","Harpia"],
    ["Rydwan","Więźniarka"]
  ],
  "Khazadzi z Gór Krańca Świata": [
    ["Kowal run","Mistrz inżynier"],
    ["Strzelec","Górnik"]
  ],
  "Kult Pogromców z Karak Kadrin": [
    ["Kowal run","Mistrz inżynier"]
  ],
  "Kompania krasnoludzkich Piwowarów": [
    ["Kowal run","Mistrz inżynier"],
    ["Pogromca trolli","Krasnoludzki przepatrywacz"],
    ["Zaprzęg","Powóz piwny"]
  ],
  "Szkutnicy z Barak Varr": [
    ["Kowal run","Mistrz inżynier"],
    ["Ogr","Ptasznik z Barak Varr"],
    ["Balon bojowy","Żyrokopter"]
  ],
  "Jeźdźcy Wilków": [
    ["Więźniarka","Rydwan"]
  ],
  "Zwiadowcza kompania z Królestw Ogrów": [
    ["Ogniobrzuchy (ogr)","Rzeźnik (ogr)"],
    ["Gorger","Yeti"]
  ],
  "Kult Ducha Chaosu": [
    ["Furia Chaosu","Zwierzoczłek"],
    ["Ogr Chaosu","Troll Chaosu"]
  ],
  "Kult Dzieci Zagłady": [
    ["Nurglingi","Plagogor"],
    ["Ogr Chaosu","Troll Chaosu"]
  ],
  "Grasanci Chaosu": [
    ["Odrzucony","Zwierzoczłek"],
    ["Kawalerzysta Chaosu","Ogar Chaosu"],
    ["Ogr Chaosu","Smoczy ogr","Troll Chaosu"],
    ["Więźniarka","Rydwan"]
  ],
  "Karnawał Chaosu": [
    ["Harlekin","Mocarz"],
    ["Furia Chaosu","Piekielny ogar","Nurgling","Bólożądna pieszczota","Różowy strachulec"],
    ["Tyralier","Ogar Chaosu"]
  ],
  "Zbrojne stado Zwierzoludzi": [
    ["Grabieżcy","Harpia"]
  ],
  "Nieumarła świta hrabiego von Carstein": [
    ["Graveir","Mroczny wilk"],
    ["Czarna Karoca","Ścierwowóz"]
  ],
  "Nieumarły orszak księżnej Lahmi": [
    ["Gnilec","Graveir"],
    ["Czarna Karoca","Ścierwowóz"]
  ],
  "Nieumarły poczet Krwawego Smoka": [
    ["Ghoul","Wicht"],
    ["Czarny rycerz","Graveir"],
    ["Rydwan","Ścierwowóz"]
  ],
  "Nieumarły sabat rodu Nekrarch": [
    ["Ghoul","Wicht"],
    ["Graveir","Rój nietoperzy"],
    ["Czarna karoca","Ścierwowóz"]
  ],
  "Nieumarły tabor ludu Strigosu": [
    ["Graveir","Stregoica"],
    ["Czarna karoca","Ścierwowóz"]
  ],
  "Nieumarła horda Liczmistrza": [
    ["Ghoul","Wicht"],
    ["Czarny rycerz","Graveir","Mroczny wilk","Rój nietoperzy"],
    ["Rydwan","Ścierwowóz"]
  ],
  "Nieumarły zastęp z Nehekhary": [
    ["Nieumarły rój","Nieumarły nomada"],
    ["Gnilec","Ushabti","Grobowy skorpion"]
  ],
  "Zwiadowcze stado klanu Eshin": [
    ["Rydwan","Więźniarka"]
  ],
  "Poganiacze klanu Moulder": [
    ["Ambulatorium","Więźniarka"]
  ],
  "Kult Zarazy klanu Pestilens": [
    ["Szczur zarazy","Czerw zarazy"],
    ["Zarazowóz","Więźniarka"]
  ],
  "Harcownicy klanu Skryre": [
    ["Koło zagłady","Więźniarka"]
  ],
  "Zbrojne stado klanu Mors": [
    ["Wóz bojowy","Więźniarka"]
  ],
  "Łowcze plemię Dzikich Orków": [
    ["Dziki ork na dziku","Troll","Wielki Pajonk"]
  ],
  "Plemię Leśnych Goblinów": [
    ["Troll","Wielki pajonk"]
  ],
  "Orkowie & Gobliny": [
    ["Ork na dziku","Troll"]
  ],
  "Nocne Gobliny": [
    ["Troll","Wielki squig"],
    ["Rydwan","Więźniarka"]
  ],
  "Załoga Zielonoskórych Kaprów": [
    ["Squig","Kaper"],
    ["Troll","Ośmiornica bagienna"],
    ["Więźniarka","Rydwan"]
  ],
  "Jaszczuroludzie z Lustrii": [
    ["Jeździec zimnokrwistych","Jeździec terradonów"],
    ["Salamandra","Kroxigor"],
    ["Wóz bojowy","Rydwan"]
  ],
  "Kult Sybarytów": [
    ["Bólożądna pieszczota","Slaangor"]
  ],
  "Kult Karmazynowej Czaszki": [
    ["Piekielny ogar","Khorngor"],
    ["Ogr Chaosu","Troll Chaosu"]
  ],
  "Kult Purpurowej Dłoni": [
    ["Tzaangor","Różowy strachulec"],
    ["Smoczy ogr","Troll Chaosu"]
  ],
  "Bractwo Rycerskie": [
    ["Kapłan Mananna","Kapłan Morra","Kapłan Myrmidii","Kapłan Ranalda","Kapłan Ulryka","Kapłan Ursuna","Prezbiter Sigmara"],
    ["Flagelant","Gwardzista"],
    ["Bitewny ołtarz","Rydwan"]
  ],
  "Emisariusze Smoczego Cesarza": [
    ["Smoczy lansjer","Nomada"],
    ["Kirin","Pies świątynny"],
    ["Balon bojowy","Bitewny ołtarz"]
  ],
  "Klan wojowników z Nipponu": [
    ["Kabuki","Yabusame"],
    ["Oni","Tengu"],
    ["Balon bojowy","Wóz bojowy"]
  ],
  "Berserkerzy z Norski": [
    ["Berserker","Ogar Chaosu"],
    ["Zniewolony Troll","Yeti"],
    ["Więźniarka","Bitewny ołtarz"]
  ],
  "Konwent magów Wieży Hoeth": [
    ["Balon bojowy","Relikwiarz mocy"]
  ],
  "Bestiobójcy z Kraka Drak": [
    ["Pogromca Trolli","Szablozębny"],
    ["Zniewolony troll","Niedźwiedź"]
  ],
  "Łupieżcza kompania Fimirów": [
    ["Ośmiornica Bagienna","Bagienna Bestia"],
    ["Więźniarka","Rydwan"]
  ],
  "Eteryczny dwór Króla kurhanów": [
    ["Upiór","Zjawa"],
    ["Widmo","Banshee"]
  ]
};
